<template>
	<div>
		<AppFileUpload
			:uploadedFile="workflowAppearanceSettings.background_file"
			:uploadFunc="uploadFunc"
			placeholder="Select your background image"
			accept="image/png, image/jpg"
			@onFileUploaded="updateWorkflowVersionSettings"
		/>
	</div>
</template>

<script>
import api from '@/api';
import { mapGetters, mapActions } from 'vuex';
import { updateWorkflowSetting } from '@/store/modules/selectedWorkflow/actions.js';
import { getWorkflowAppearanceSettings } from '@/store/modules/selectedWorkflow/getters.js';

export default {
	name: 'FeatureBackgroundFileUpload',
	computed: {
		...mapGetters([getWorkflowAppearanceSettings.fullPath]),
		workflowAppearanceSettings() {
			return this[getWorkflowAppearanceSettings.fullPath];
		},
		isUploadedImage() {
			return !!this.workflowAppearanceSettings.background_file;
		},
	},
	methods: {
		...mapActions([updateWorkflowSetting.fullPath]),
		updateWorkflowVersionSettings(value) {
			if (value) {
				this[updateWorkflowSetting.fullPath]({ key: 'background', value: null });
			} else {
				this[updateWorkflowSetting.fullPath]({ key: 'background_file', value });
			}
		},
		async uploadFunc(file) {
			const r = await api.updateWorkflowSettingImage(this.workflowAppearanceSettings.id, file, 'background_file');
			return r.background_file;
		},
	},
	data() {
		return {
			loading: false,
			uploadProgress: 0,
			outlinedInput: false, //Customization for WidgetFieldMixin default behavior
		};
	},
};
</script>
<style scoped lang="scss">
.delete-button {
	width: 89px;
	height: 25px !important;
	color: var(--button-text);
	font-size: 12px !important;
	border: 1px solid var(--button-text);
	background: var(--bg-color) !important;
}

.file-input {
	::v-deep {
		.v-label {
			top: 8px !important;
		}
		.v-input__prepend-outer {
			margin-top: 6px !important;
		}
	}
}
</style>
